import { IEmptySpace } from './EmptySpace.types';

export default function EmptySpace({ count = 1 }: IEmptySpace) {
  return <>{Array.from({ length: count }).map(() => '\u00A0')}</>;
}
